
import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { MapContainer, TileLayer, Polygon, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const ViewModal = ({ open, onClose, data }) => {
    const coordinates = data?.polygon?.coordinates || [];
    const rawCoords = Array.isArray(coordinates[0]?.[0]) ? coordinates[0] : coordinates;

    // Convert to [lat, lng] for Leaflet
    const polygonCoords = rawCoords.map(([lng, lat]) => [lat, lng]);

    // Use the first polygon point as city point
    const cityPoint = polygonCoords[0] || [0, 0];
    const polygonBounds = polygonCoords.length ? polygonCoords : null;

    const mapProps = polygonBounds
        ? {
            bounds: polygonBounds,
            boundsOptions: { padding: [20, 20] },
        }
        : {
            center: cityPoint,
            zoom: 10,
        };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant="h6">Service Area Details</Typography>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ p: 2 }}>
                <Box mb={2}>
                    <Typography variant="subtitle1">
                        <strong>City:</strong> {data?.city || "-"}
                    </Typography>
                </Box>

                <MapContainer
                    {...mapProps}
                    style={{ height: "400px", width: "100%" }}
                >
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; OpenStreetMap contributors'
                    />

                    {polygonCoords.length > 0 && (
                        <Polygon positions={polygonCoords} color="blue">
                            <Popup>{data.city} Polygon</Popup>
                        </Polygon>
                    )}
                </MapContainer>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }} />
        </Dialog>
    );
};

export default ViewModal;
